import { render, staticRenderFns } from "./ArticleHeadOtherFields.vue?vue&type=template&id=2010ed45&scoped=true&"
import script from "./ArticleHeadOtherFields.vue?vue&type=script&lang=js&"
export * from "./ArticleHeadOtherFields.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHeadOtherFields.vue?vue&type=style&index=0&id=2010ed45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010ed45",
  null
  
)

export default component.exports